export function shouldPurgeProtectedPhotoCache(
  previousMatchId: string | null | undefined,
  currentMatchId: string | null,
) {
  if (currentMatchId === null) return true;
  return previousMatchId !== undefined && previousMatchId !== currentMatchId;
}

export function createProtectedPhotoAccessTracker() {
  const previousMatchByUser = new Map<string, string | null>();

  return {
    update(userId: string, currentMatchId: string | null) {
      const previousMatchId = previousMatchByUser.has(userId)
        ? previousMatchByUser.get(userId)
        : undefined;
      previousMatchByUser.set(userId, currentMatchId);
      return shouldPurgeProtectedPhotoCache(previousMatchId, currentMatchId);
    },
  };
}

// MatchHome can unmount while someone visits another part of the SPA. Keep the
// last access scope for this browser session outside that route so returning
// after an introduction changes still purges the former match's blobs.
export const protectedPhotoAccessTracker = createProtectedPhotoAccessTracker();
